module.exports = __webpack_public_path__ + "media/luxury-2026/loch-fireplace-straight-960-235a3087.jpg";